import Api from '../api.js';

export default () => ({
    async fetchAccessToken(subDomain, code, codeVerifier, redirectUri) {
        return await Api.postJSON(
            `/oidc/${subDomain}/fetch-access-token`,
            {
                code,
                codeVerifier,
                redirectUri,
            },
            false
        )
            .then(Api.handle)
            .catch(Api.error);
    },
    async fetchRefreshToken() {
        return await Api.get('/oidc/exchange-refresh-token', true, true)
            .then(Api.handle)
            .catch(error => error);
    },
});
